module.exports = __webpack_public_path__ + "static/media/stepup.fb8cb602.webp";